import { render, staticRenderFns } from "./ProductTotalSales.vue?vue&type=template&id=157cf308&"
import script from "./ProductTotalSales.vue?vue&type=script&lang=js&"
export * from "./ProductTotalSales.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports